export default __webpack_public_path__ + "assets/boardSpec.423ea620.JPG";